import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RegistrationProvider } from './context/RegistrationContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Public Pages
import Home from './pages/public/Home';
import Candidates from './pages/public/Candidates';
import CandidateProfile from './pages/public/CandidateProfile';
import Donations from './pages/public/Donations';
import PaymentCallback from './pages/public/PaymentCallback';
import CheckKycStatus from './pages/public/CheckKycStatus';
import Security from './pages/public/Security';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';

// User Pages
import Profile from './pages/user/Profile';
import MyDonations from './pages/user/MyDonations';
import MyReports from './pages/user/MyReports';
import Reports from './pages/public/Reports';

// Admin Pages
import Dashboard from './pages/admin/Dashboard';
import UserManagement from './pages/admin/UserManagement';
import CandidateManagement from './pages/admin/CandidateManagement';
import AdminManagement from './pages/admin/AdminManagement';
import CandidateFormPage from './pages/admin/CandidateFormPage';
import DocumentUpload from './pages/admin/DocumentUpload';
import FAQManagement from './pages/admin/FAQManagement';
import ManageVouchers from './pages/admin/ManageVouchers';

function App() {
  return (
    <Router>
      <AuthProvider>
        <RegistrationProvider>
          <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />
            <main className="flex-grow">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/candidates" element={<Candidates />} />
                <Route path="/candidates/:linkOrId" element={<CandidateProfile />} />
                <Route path="/donations" element={<Donations />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/payment/verify" element={<PaymentCallback />} />
                <Route path="/check-kyc-status" element={<CheckKycStatus />} />
                <Route path="/security" element={<Security />} />

                {/* Auth Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* Protected User Routes */}
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/my-donations"
                  element={
                    <ProtectedRoute>
                      <MyDonations />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/my-reports"
                  element={
                    <ProtectedRoute>
                      <MyReports />
                    </ProtectedRoute>
                  }
                />

                {/* Protected Candidate Routes */}
                <Route
                  path="/candidate/my-profile"
                  element={
                    <ProtectedRoute candidateOnly>
                      <CandidateFormPage />
                    </ProtectedRoute>
                  }
                />

                {/* Protected Admin Routes */}
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute adminOnly>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/users"
                  element={
                    <ProtectedRoute adminOnly>
                      <UserManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/candidates"
                  element={
                    <ProtectedRoute adminOnly>
                      <CandidateManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/candidates/new"
                  element={
                    <ProtectedRoute adminOnly>
                      <CandidateFormPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/candidates/:id/edit"
                  element={
                    <ProtectedRoute adminOnly>
                      <CandidateFormPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/donations"
                  element={
                    <ProtectedRoute adminOnly>
                      <Donations />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/admins"
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/documents"
                  element={
                    <ProtectedRoute adminOnly>
                      <DocumentUpload />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/faqs"
                  element={
                    <ProtectedRoute adminOnly>
                      <FAQManagement />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/vouchers"
                  element={
                    <ProtectedRoute adminOnly>
                      <ManageVouchers />
                    </ProtectedRoute>
                  }
                />

                {/* 404 Route */}
                <Route
                  path="*"
                  element={
                    <div className="min-h-screen flex items-center justify-center">
                      <div className="text-center">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                        <p className="text-gray-600">Page not found</p>
                      </div>
                    </div>
                  }
                />
              </Routes>
            </main>
            <Footer />
          </div>
        </RegistrationProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
